import React from "react";

import css from "../css/restriction.module.css";

export const Restriction = ({restriction}) => {
    return (
        <div className={css.restriction}>
            {restriction}
        </div>
    )
}
